import React from "react";
import { useTranslation } from "react-i18next";
import { Theme } from "./Theme";
import { IWebsiteBuilderTheme } from "redux/reducers/models/websiteBuilder";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { websiteBuilderSelectTheme } from "redux/actions/websiteBuilder/editor/websiteBuilderEditor";
import { WebsiteBuilderToolbarMenuView } from "../../../WebsiteBuilderToolbarMenuView";

interface IThemesViewProps {
  goBackToParentView: () => void;
}

export function ThemesView(props: IThemesViewProps) {
  const { goBackToParentView } = props;

  const { t } = useTranslation();

  const theme = useAppSelector(store => store.websiteBuilderStore.editor.theme);
  const availableThemes = useAppSelector(store => store.websiteBuilderStore.editor.availableThemes);

  const dispatch = useAppDispatch();

  function renderCurrentThemeSection() {
    return <Theme theme={theme} selected={true} />;
  }

  function selectTheme(theme: IWebsiteBuilderTheme) {
    dispatch(websiteBuilderSelectTheme({ id: theme?.id }));
  }

  function renderFeaturedThemesSection() {
    return (
      <>
        {availableThemes?.map(availableTheme => (
          <Theme
            key={availableTheme?.id}
            theme={availableTheme}
            selected={false}
            selectTheme={() => selectTheme(availableTheme)}
          />
        ))}
      </>
    );
  }

  return (
    <WebsiteBuilderToolbarMenuView
      title={t("Themes")}
      goBackToParentView={goBackToParentView}
      sections={[
        {
          title: t("Current Theme"),
          content: renderCurrentThemeSection(),
        },
        {
          title: t("Featured Themes"),
          content: renderFeaturedThemesSection(),
        },
      ]}
    />
  );
}
